import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BorderThickness = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4C2 3.44772 2.44772 3 3 3H13C13.5523 3 14 3.44772 14 4C14 4.55228 13.5523 5 13 5H3C2.44771 5 2 4.55228 2 4ZM2 8.66665C2 8.29846 2.29848 7.99998 2.66667 7.99998H13.3333C13.7015 7.99998 14 8.29846 14 8.66665C14 9.03484 13.7015 9.33331 13.3333 9.33331H2.66667C2.29848 9.33331 2 9.03484 2 8.66665ZM2.33333 12.3334C2.14924 12.3334 2 12.4826 2 12.6667C2 12.8508 2.14924 13.0001 2.33333 13.0001H13.6667C13.8508 13.0001 14 12.8508 14 12.6667C14 12.4826 13.8508 12.3334 13.6667 12.3334H2.33333Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default BorderThickness
